/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentMethods = {
    TOKEN: 'TOKEN',
    CREDIT: 'CREDIT',
    SPLIT: 'SPLIT',
    COINBASE: 'COINBASE',
    NONE: 'NONE'
} as const;
export type PaymentMethods = typeof PaymentMethods[keyof typeof PaymentMethods];


export function instanceOfPaymentMethods(value: any): boolean {
    for (const key in PaymentMethods) {
        if (Object.prototype.hasOwnProperty.call(PaymentMethods, key)) {
            if (PaymentMethods[key as keyof typeof PaymentMethods] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaymentMethodsFromJSON(json: any): PaymentMethods {
    return PaymentMethodsFromJSONTyped(json, false);
}

export function PaymentMethodsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethods {
    return json as PaymentMethods;
}

export function PaymentMethodsToJSON(value?: PaymentMethods | null): any {
    return value as any;
}

export function PaymentMethodsToJSONTyped(value: any, ignoreDiscriminator: boolean): PaymentMethods {
    return value as PaymentMethods;
}

